<template>
  <div class="pc_wrap">
    <!-- 切页内容 -->
    <swiper
      class="page_slider"
      :modules="[Lazy]"
      :direction="'vertical'"
      :mousewheel="{ releaseOnEdges: true }"
      :allow-touch-move="false"
      :lazy="{ loadPrevNext: true, loadOnTransitionStart: true }"
      :preloadImages="false"
      :speed="500"
      @swiper="onSwiper"
      @slideChangeTransitionEnd="onSlideChange"
      @init="onSwiperInit"
    >
      <!-- 首页 -->
      <swiper-slide class="page page1">
        <div class="page_video">
          <video
            src="/media/bg.mp4"
            loop
            autoplay
            muted
            crossorigin="anonymous"
            preload="auto"
            id="index_video"
          ></video>
        </div>
        <div class="top_mask pa"></div>
        <div class="center_content">
          <a href="javascript:;" class="btn_vid pa" @click="showVideo()"></a>
          <div class="slogan pa">
            <img :src="slgSrc" alt="" />
          </div>
          <a
            href="javascript:;"
            class="btn_order pa"
            @click="appointment()"
            v-if="!reservationStatus"
            >立即预约</a
          >
          <a href="javascript:;" class="btn_order pa" v-else>已预约</a>
          <div class="order_bum pa">
            全平台预约人数: <span>{{ mileNum }}</span>
          </div>
        </div>
        <div class="scroll_icon pa"></div>
        <div
          class="age_icon pa"
          @click="
            () => {
              homeOnAgeTipsClickReporting();
              popSl = true;
            }
          "
        ></div>
        <div
          class="hd_link pa"
          @click="
            () => {
              homeOnOfficialSiteClickReporting();
              openUrl(getGithubUrl());
            }
          "
        >
          <div class="bgm_tips">进入概念站</div>
        </div>
        <div class="rbottom pa">
          <div :class="showRbut ? 'rbottom_icon' : 'rbottom_icon bhide'">
            <a
              href="javascript:;"
              class="ricon1"
              @click="
                () => {
                  wxPop = true;
                  homeOnOfficialMediaClickReporting(1);
                }
              "
            ></a>
            <a
              href="javascript:;"
              @click="
                () => {
                  openUrl('https://weibo.com/u/7947701804');
                  homeOnOfficialMediaClickReporting(2);
                }
              "
              target="_blank"
              class="ricon2 db"
            ></a>
            <a
              href="javascript:;"
              @click="
                () => {
                  openUrl(
                    'https://l.taptap.cn/QEnaLNZi?channel=rep-rep_bemummkj8nj'
                  );
                  homeOnOfficialMediaClickReporting(3);
                }
              "
              target="_blank"
              class="ricon3"
            ></a>
            <a
              href="javascript:;"
              @click="
                () => {
                  openUrl('https://space.bilibili.com/3546757206116480');
                  homeOnOfficialMediaClickReporting(4);
                }
              "
              target="_blank"
              class="ricon4 db"
            ></a>
            <a
              href="javascript:;"
              class="ricon5 db"
              @click="
                () => {
                  qqPop = true;
                  homeOnOfficialMediaClickReporting(5);
                }
              "
            ></a>
          </div>
          <a
            href="javascript:;"
            :class="showRbut ? 'r_hide' : 'r_hide bhide'"
            @click="showRbut = !showRbut"
          ></a>
        </div>
      </swiper-slide>
      <!-- 角色 -->
      <swiper-slide class="page page2">
        <div class="js_bg">
          <video
            src="/img/pc/bg2.mp4"
            loop
            muted
            autoplay
            id="bg2_video"
          ></video>
        </div>
        <!-- 角色内容 -->
        <div class="rw_con">
          <template
            v-for="(character, characterIndex) in characterData"
            :key="character.id"
          >
            <div
              :class="`rw_box ${character.className}`"
              v-show="jsnum === characterIndex"
            >
              <!-- 角色立绘 -->
              <div class="rw_lihui">
                <img :src="character.image" alt="" class="rw_img" />
              </div>
              <!-- 角色文案-->
              <div class="rw_left">
                <template
                  v-for="(typeData, typeIndex) in character.descriptions"
                  :key="typeIndex"
                >
                  <div class="rw_info" v-if="jstype === typeIndex + 1">
                    <div class="rw_name">
                      <img :src="character.names[typeIndex]" alt="" />
                    </div>
                    <div class="rw_txt">
                      <p class="r_txts r_txts1" v-html="typeData[0]"></p>
                      <p class="r_txts" v-html="typeData[1]"></p>
                    </div>
                  </div>
                </template>
                <!-- 切换 颂灵者/使灵 -->
                <div class="rw_tab1">
                  <a
                    href="javascript:;"
                    :class="jstype == 1 ? 'tab1 db cur' : 'tab1 db'"
                    @click="changeJstype"
                    >颂灵者</a
                  >
                  <a
                    href="javascript:;"
                    :class="jstype == 2 ? 'tab2 db cur' : 'tab2 db'"
                    @click="changeJstype"
                    >使灵</a
                  >
                </div>
              </div>
            </div>
          </template>
        </div>
        <!-- 右侧切换颂灵者角色 -->
        <div class="rw_tab2">
          <swiper
            class="rw_tabslider"
            :slidesPerView="3"
            :loop="true"
            :centeredSlides="true"
            :allow-touch-move="false"
            @swiper="onSwiper3"
            @slideChangeTransitionEnd="onSlideChange3"
          >
            <swiper-slide
              v-for="character in characterData"
              :key="character.id"
            >
              <div class="tx_img">
                <img :src="character.iconImages[jstype - 1]" alt="" />
                <a
                  href="javascript:;"
                  class="rwtab_prev"
                  @click="goToPrev()"
                ></a>
                <a
                  href="javascript:;"
                  class="rwtab_next"
                  @click="goToNext()"
                ></a>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </swiper-slide>
      <!-- 地图 -->
      <swiper-slide class="page page3">
        <div class="top_mask pa"></div>
        <div class="bottom_mask pa"></div>
        <div class="map_con">
          <div class="map_box" v-show="mapNum == 1">
            <video
              src="/media/map2s.mp4"
              loop
              :muted="!mapSounds"
              class="map_video"
              id="map_vid1"
              poster="/img/pc/map2.jpg"
            ></video>
            <img src="/img/pc/map_txt2.png" alt="" class="map_txt" />
          </div>
          <div class="map_box" v-show="mapNum == 2">
            <video
              src="/media/map1s.mp4"
              loop
              :muted="!mapSounds"
              class="map_video"
              id="map_vid2"
              poster="/img/pc/map1.jpg"
            ></video>
            <img src="/img/pc/map_txt1.png" alt="" class="map_txt" />
          </div>
          <div class="map_box" v-show="mapNum == 3">
            <video
              src="/media/map3s.mp4"
              loop
              :muted="!mapSounds"
              class="map_video"
              id="map_vid3"
              poster="/img/pc/map3.jpg"
            ></video>
            <img src="/img/pc/map_txt3.png" alt="" class="map_txt" />
          </div>
          <!-- <div class="map_box" v-show="mapNum == 4">
            <video
              src="/media/map4s.mp4"
              loop
              :muted="!mapSounds"
              class="map_video"
              id="map_vid4"
              poster="/img/pc/map4.jpg"
            ></video>
            <img src="/img/pc/map_txt4.png" alt="" class="map_txt" />
          </div> -->
          <div class="map_box" v-show="mapNum == 4">
            <video
              src="/media/map5s.mp4"
              loop
              :muted="!mapSounds"
              class="map_video"
              id="map_vid4"
              poster="/img/pc/map5.jpg"
            ></video>
            <img src="/img/pc/map_txt5.png" alt="" class="map_txt" />
          </div>
        </div>
        <div class="map_tab">
          <swiper
            class="map_slider"
            :slidesPerView="5"
            :loop="true"
            :centeredSlides="true"
            :allow-touch-move="false"
            @swiper="onSwiper4"
            @slideChange="onSlideChange4"
          >
            <swiper-slide>
              <div class="map_click">
                <p class="map_name">洛伦城</p>
                <div class="map_icon"></div>
                <a href="javascript:;" class="map_prev" @click="mapPrev()"></a>
                <a href="javascript:;" class="map_next" @click="mapNext()"></a>
                <a href="javascript:;" class="map_to"></a>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="map_click">
                <p class="map_name">智思海</p>
                <div class="map_icon"></div>
                <a href="javascript:;" class="map_prev" @click="mapPrev()"></a>
                <a href="javascript:;" class="map_next" @click="mapNext()"></a>
                <a href="javascript:;" class="map_to"></a>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="map_click">
                <p class="map_name">夕影村</p>
                <div class="map_icon"></div>
                <a href="javascript:;" class="map_prev" @click="mapPrev()"></a>
                <a href="javascript:;" class="map_next" @click="mapNext()"></a>
                <a href="javascript:;" class="map_to"></a>
              </div>
            </swiper-slide>
            <!-- <swiper-slide>
              <div class="map_click">
                <p class="map_name">断罪高塔</p>
                <div class="map_icon"></div>
                <a href="javascript:;" class="map_prev" @click="mapPrev()"></a>
                <a href="javascript:;" class="map_next" @click="mapNext()"></a>
                <a href="javascript:;" class="map_to"></a>
              </div>
            </swiper-slide> -->
            <swiper-slide>
              <div class="map_click">
                <p class="map_name">黄昏</p>
                <div class="map_icon"></div>
                <a href="javascript:;" class="map_prev" @click="mapPrev()"></a>
                <a href="javascript:;" class="map_next" @click="mapNext()"></a>
                <a href="javascript:;" class="map_to"></a>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <!-- <a href="javascript:;" :class="mapSounds?'map_bgm play':'map_bgm'" @click="mapSound()"></a> -->
      </swiper-slide>
      <!-- 资讯 -->
      <swiper-slide class="page page4">
        <div class="news_page">
          <div class="center_content">
            <div class="news_swiper">
              <swiper
                class="news_slider"
                :autoplay="showNews ? { delay: 4000 } : false"
                :pagination="{ clickable: true }"
                :allow-touch-move="false"
                @swiper="onSwiper2"
                @slideChange="onSlideChange2"
              >
                <template v-for="(item, index) in newsList" :key="index">
                  <swiper-slide>
                    <div
                      class="news_lb"
                      @click="$router.push('/news?id=' + item.id)"
                    >
                      <img :src="item.broadcast_image" alt="" />
                    </div>
                  </swiper-slide>
                </template>
              </swiper>
              <div class="news_pages">
                <em>{{ newsCurrent < 10 ? "0" + newsCurrent : newsCurrent }}</em
                >/<span>{{
                  newsList.length < 10 ? "0" + newsList.length : newsList.length
                }}</span>
              </div>
            </div>
            <div class="news_qbg"></div>
            <div class="news_content">
              <div class="news_tab">
                <a
                  href="javascript:;"
                  :class="newsType == 0 ? 'cur' : ''"
                  @click="changeNewsType(0)"
                  >最新</a
                >
                <a
                  href="javascript:;"
                  :class="newsType == 1 ? 'cur' : ''"
                  @click="changeNewsType(1)"
                  >新闻</a
                >
                <a
                  href="javascript:;"
                  :class="newsType == 2 ? 'cur' : ''"
                  @click="changeNewsType(2)"
                  >公告</a
                >
                <a
                  href="javascript:;"
                  :class="newsType == 3 ? 'cur' : ''"
                  @click="changeNewsType(3)"
                  >活动</a
                >
              </div>
              <ul class="news_list" v-if="newsList2">
                <template v-for="(item, index) in newsList2" :key="index">
                  <li @click="$router.push('/news?id=' + item.id)">
                    <p class="news_time">{{ formatDate(item.start_time) }}</p>
                    <p class="news_txt">
                      <em>{{ newsTypeText[item.type] }}</em
                      ><span>{{ item.title }}</span>
                    </p>
                  </li>
                </template>
              </ul>
              <div class="news_none" v-else>暂无更多内容</div>
              <a
                href="javascript:;"
                class="btn_more db"
                @click="$router.push('/list')"
                >查看更多</a
              >
            </div>
          </div>
        </div>
        <!-- 底部版权 -->
        <div class="copyright_box">
          <img src="/img/pc/footer_logo.png" alt="" class="footer_logo" />
          <img src="/img/pc/logo-white.png" alt="" class="logo_white" />
          <div class="copyright_right">
            <div class="copyright_link">
              <a
                @click="
                  openUrl(
                    'https://rule.sarosgame.com/sarosis/20250609/l6/tos.html'
                  )
                "
                target="_blank"
                >服务协议</a
              >
              |
              <a
                @click="
                  openUrl(
                    'https://rule.sarosgame.com/sarosis/20250609/l6/pp.html'
                  )
                "
                target="_blank"
                >个人信息保护规则</a
              >
              |
              <a
                @click="
                  openUrl(
                    'https://rule.sarosgame.com/sarosis/20241112/coppa.html'
                  )
                "
                target="_blank"
                >儿童个人信息保护规则</a
              >
              | <span>联系我们 15958032334</span> <br />
              <span>版权所有 © 2025 萨罗斯网络科技（深圳）有限公司</span><br />
              <span
                >联系地址：深圳市前海深港合作区南山街道梦海大道5033号卓越前海壹号T3
                L9-01</span
              ><br />
              <a href="https://beian.miit.gov.cn/" target="_blank" v-if="hasUrl"
                >粤ICP备2024185500号-1</a
              >
              <a href="https://beian.miit.gov.cn/" target="_blank" v-else
                >粤ICP备2024185500号-3</a
              >
              <span v-show="hasUrl">
                |
                <a
                  @click="openUrl('https://beian.mps.gov.cn/#/query/webSearch')"
                  target="_blank"
                  >粤公网安备44030002005143</a
                >
              </span>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <!-- 导航 -->
    <div class="top_box">
      <a href="javascript:;" class="top_logo"></a>
      <ul class="nav_list">
        <li
          :class="navNum == 0 ? 'nav1 db cur' : 'nav1 db'"
          @click="goToSlide(0)"
        >
          首页
        </li>
        <li
          :class="navNum == 1 ? 'nav2 db cur' : 'nav2 db'"
          @click="goToSlide(1)"
        >
          角色
        </li>
        <li
          :class="navNum == 2 ? 'nav3 db cur' : 'nav3 db'"
          @click="goToSlide(2)"
        >
          地图
        </li>
        <li
          :class="navNum == 3 ? 'nav4 db cur' : 'nav4 db'"
          @click="goToSlide(3)"
        >
          资讯
        </li>
      </ul>
      <div class="tright_icon">
        <div class="user_info" v-if="isLogin">
          <img :src="userImgUrl" alt="" class="user_img" />
          <span>已经登录</span>
          <a href="javascript:;" class="btn_logout" @click="logout()">登出</a>
        </div>
        <a
          href="javascript:;"
          class="btn_login"
          @click="showLogin = true"
          v-else
        ></a>
        <a
          href="javascript:;"
          :class="bgmState ? 'btn_bgm play' : 'btn_bgm'"
          @click="playBgm()"
        >
          <i></i>
          <div class="bgm_tips bgm_tips2">点击按钮开启音乐</div>
        </a>
        <a href="javascript:;" class="btn_zhuan" @click="copyLink()">
          <div class="bgm_tips" v-if="copyTips">链接已复制</div>
        </a>
      </div>
    </div>
    <!-- 视频 -->
    <div class="pop_bg" v-if="popVideo">
      <div class="video_box">
        <iframe
          src="https://player.bilibili.com/player.html?isOutside=true&aid=114646937769853&bvid=BV1crTXzDE8r&cid=30366041181&p=1"
          scrolling="no"
          border="0"
          frameborder="no"
          framespacing="0"
          allowfullscreen="true"
          width="100%"
          height="100%"
        ></iframe>
        <a href="javascript:;" class="pop_close db" @click="hideVideo()"
          >关闭</a
        >
      </div>
    </div>
    <!-- qq扫码弹窗 -->
    <div class="pop_bg" v-if="qqPop">
      <div class="wx_img">
        <img src="/img/pc/pop_qq.jpg" alt="" />
        <a href="javascript:;" class="pop_close db" @click="qqPop = false"
          >关闭</a
        >
      </div>
    </div>
    <!-- 微信扫码弹窗 -->
    <div class="pop_bg" v-if="wxPop">
      <div class="wx_img">
        <img src="/img/pc/wx.jpg" alt="" />
        <a href="javascript:;" class="pop_close db" @click="wxPop = false"
          >关闭</a
        >
      </div>
    </div>
    <!-- 预约弹窗 -->
    <Order
      :visible="showOrder"
      @close="
        () => {
          getReservationStatus();
          showOrder = false;
        }
      "
    />

    <!-- 登录弹窗 -->
    <Login :visible="showLogin" @close="showLogin = false" />
    <!-- 新增适龄弹窗 -->
    <div class="pop_mask" v-if="popSl">
      <div class="pop_content pop_sl">
        <div class="pop_info">
          <div class="login_title">适龄提示</div>
          <ul class="sl_txt">
            <li>
              1.本游戏是一款开放世界动作类游戏，适用于年满16周岁以上的用户，建议未成年人在监护人的监护下使用游戏产品。
            </li>
            <li>
              2.本游戏基于架空世界展开剧情，采用风格鲜明的美术设计、精美的游戏画面，优质的游戏配乐以及新颖的系统玩法。
            </li>
            <li>
              3.本游戏中有用户实名认证系统，认证为未成年的用户将受到以下游戏的限制：<br />
              未满8周岁的用户不能充值；8周岁以上未满16周岁的未成年用户，单次充值金额不得超过50元人民币，每月充值金额累计不得超过200元人民币；16周岁以上的未成年用户，单次充值金额不得超过100元人民币，每月充值金额累计不得超过400元人民币。<br />
              游戏仅会在周五、周六、周日和法定节假日的20时至21时，向未成年人提供1小时游戏服务。
            </li>
            <li>
              4.本游戏设置了主线、支线剧情，通过对话与交互推动剧情，游戏还提供了开放世界探索玩法。游戏内提供了少量基于文字的陌生人社交系统，该社交系统遵循相关法律法规进行管理。
            </li>
          </ul>
        </div>
        <a href="javascript:;" @click="popSl = false" class="pop_close db"
          >关闭</a
        >
      </div>
    </div>

    <!-- bgm -->
    <audio src="media/bgm.mp3" loop class="bgm"></audio>

    <!-- 地图点击音 -->
    <audio
      src="media/map_click.mp3"
      class="map_clickbgm"
      :muted="!mapSounds"
      id="map_clickbgm"
    ></audio>
  </div>
</template>

<script setup>
import {
  homeOnOfficialMediaClickReporting,
  homeOnOfficialSiteClickReporting,
  homeOnAgeTipsClickReporting,
  homeOnOfficialMediaAppointClickReporting,
  homeOnPlayClickReporting,
  homeOnMapClickReporting,
  homeOnRoleClickReporting,
} from "@/utils/reporting";
import { ref, onMounted, onUnmounted, computed } from "vue"; // 导入vue
import { useRouter } from "vue-router"; // 导入 useRouter
import { Swiper, SwiperSlide } from "swiper/vue";
import { Lazy } from "swiper";
import "swiper/css";
import "swiper/css/lazy";
import "swiper/css/mousewheel";
import "swiper/css/pagination"; // 引入分页器样式
import SwiperCore, { Mousewheel, Autoplay, Pagination } from "swiper";
import Order from "@/components/Order.vue"; // 引入弹窗组件
import Login from "@/components/Login.vue"; // 引入弹窗组件
import { formatDate } from "@/utils/formatDate"; // 导入时间格式化函数
import { getNewsList, getMilestone, getReservation } from "@/api"; // 导入api
import { toast } from "vue3-toastify"; // 引入toast组件
import { getToken, removeToken, getHeadImg } from "@/utils/qwLogin";
import { isInWeChatWork, isInQQWork, getGithubUrl } from "@/utils"; // 判断是否在微信工作台
import { pcCharacterData } from "@/config/characterData";
const hasUrl = window.location.host.includes("sarosgame.com");

// 整个页面的Swiper实例
const mySwiper = ref(null); // 定义一个ref来保存Swiper实例

// 设置html和body的高度为100%
document.documentElement.style.height = "100%";
document.body.style.height = "100%";

// toast.info("正在加载中...");
// 3s后音乐按钮提示消失
setTimeout(() => {
  document.querySelector(".bgm_tips2").style.display = "none";
}, 4000);

function showToast(msg) {
  toast.info(msg);
}

const openUrl = (url) => {
  window.open(url, "_blank");
};

const qqPop = ref(false); // 定义一个ref来保存qq扫码弹窗状态
const wxPop = ref(false); // 定义一个ref来保存微信扫码弹窗状态
const popSl = ref(false); // 定义一个ref来保存适龄提示弹窗状态

// 弹窗状态
const showOrder = ref(false); // 预约弹窗
const showLogin = ref(false); // 登录弹窗
const reservationStatus = ref(false);
const isLogin = computed(() => {
  return getToken();
});
const userImgUrl = getHeadImg();

// 双端适配
const router = useRouter(); // 获取路由实例
const isPt = () => {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  if (isMobile) {
    router.push("/mobile");
  } else {
    router.push("/");
  }
};
const appointment = () => {
  homeOnOfficialMediaAppointClickReporting();
  if (!isLogin.value) {
    showLogin.value = true;
  } else {
    showOrder.value = true;
  }
};

// 查询预约状态
const getReservationStatus = async () => {
  try {
    const res = await getReservation();
    reservationStatus.value = res.result;
  } catch (error) {
    reservationStatus.value = false;
  }
};

const logout = () => {
  removeToken();
};

onMounted(() => {
  if (isLogin.value) {
    getReservationStatus();
  }
});
onMounted(() => {
  isPt();
  setTimeout(() => {
    document.dispatchEvent(new Event("render-event"));
  });
  window.addEventListener("resize", isPt);

  // 最后一屏滑动
  setTimeout(() => {
    pageScroll();
  }, 500);
});
onUnmounted(() => {
  window.removeEventListener("resize", isPt);
});

function pageScroll() {
  const scrollArea = document.querySelector(".page4");
  scrollArea.addEventListener(
    "wheel",
    (e) => {
      const el = e.currentTarget;
      const atTop = el.scrollTop === 0;
      const atBottom = el.scrollHeight - el.scrollTop === el.clientHeight;
      const scrollingDown = e.deltaY > 0;

      if (scrollingDown && !atBottom) {
        // 如果向下滚动且不在底部，则滚动到底部
        document.getElementsByClassName("top_box")[0].style.display = "none";
        e.stopPropagation();
      } else if (!scrollingDown && !atTop) {
        // 如果向上滚动且不在顶部，则滚动到顶部
        document.getElementsByClassName("top_box")[0].style.display = "flex";
        e.stopPropagation();
      }
    },
    { passive: false }
  );
}
// bgm播放
const bgmState = ref(false); // 定义一个ref来保存bgm播放状态
const pageClick = ref(false); // 定义一个ref来保存是否点击过页面
const mapSounds = ref(false); // 定义一个ref来保存地图页音效开关
const playBgm = () => {
  if (bgmState.value) {
    document.querySelector(".bgm").pause();
    mapSounds.value = false;
    bgmState.value = false;
  } else {
    if (mySwiper.value.activeIndex == 2) {
      //如果是在地图页面，则恢复地图页声音
      mapSounds.value = true;
    }
    document.querySelector(".bgm").play();
    bgmState.value = true;
  }
  console.log(mySwiper.value.activeIndex);
};
document.body.addEventListener(
  "click",
  () => {
    if (!popVideo.value) {
      document.querySelector(".bgm").play();
      bgmState.value = true;
      if (mySwiper.value.activeIndex == 2) {
        //如果是在地图页面，则恢复地图页声音
        mapSounds.value = true;
      }
    }
    pageClick.value = true;
  },
  { once: true }
);

// 预约数量
const mileNum = ref(0); // 定义一个ref来保存预约数量
onMounted(async () => {
  try {
    // 获取新闻列表
    const res = await getMilestone();
    mileNum.value = res.total;
    // console.log(res.total);
  } catch (e) {
    console.warn(e);
  }
});

// Swiper新闻
const newsList = ref([]); // 轮播新闻初始为空数组
const newsList2 = ref([]); // 右侧新闻初始为空数组
onMounted(async () => {
  try {
    // 获取新闻列表
    const res = await getNewsList(1, 4);
    newsList.value = res.list;
    newsList2.value = res.list;
  } catch (e) {
    console.warn(e);
  }
});
const newsCurrent = ref(0); // 定义一个ref来保存当前新闻的索引
const mySwiper2 = ref(null); // 定义一个ref来保存Swiper实例
const onSwiper2 = (swiper2) => {
  mySwiper2.value = swiper2;
  newsCurrent.value = mySwiper2.value.activeIndex + 1;
};
const onSlideChange2 = () => {
  if (mySwiper2.value) {
    // 增加空值检查
    newsCurrent.value = mySwiper2.value.activeIndex + 1;
  }
};
// 切换新闻类型
const newsType = ref(0); // 定义一个ref来保存当前新闻类型
const newsTypeText = ["最新", "新闻", "公告", "活动"]; // 定义新闻类型文本
const changeNewsType = (type) => {
  //切换新闻类型，只显示对应type的新闻
  newsType.value = type;
  //重新请求新闻列表
  getNewsList(1, 4, type).then((res) => {
    newsList2.value = res.list;
  });
};

//角色部分
const jsnum = ref(0); // 当前角色在数组中的索引 (0-based)
const jstype = ref(1); // 角色1的两种属性索引

// 角色数据配置
const characterData = pcCharacterData;
// 角色切换swiper
const mySwiper3 = ref(null); // 定义一个ref来保存Swiper实例
const onSwiper3 = (swiper3) => {
  mySwiper3.value = swiper3;
};
const onSlideChange3 = () => {
  if (mySwiper3.value) {
    // 增加空值检查
    jsnum.value = mySwiper3.value.realIndex;
    const currentCharacter = characterData[jsnum.value];
    if (currentCharacter) {
      homeOnRoleClickReporting(
        jstype.value == 1 ? currentCharacter.id : currentCharacter.id + 3
      );
    }
  }
};
const goToNext = () => {
  mySwiper3.value.update();
  mySwiper3.value.slideNext();
};
const goToPrev = () => {
  mySwiper3.value.update();
  mySwiper3.value.slidePrev();
};

// 颂灵切换
const changeJstype = () => {
  jstype.value = jstype.value == 1 ? 2 : 1;
  const currentCharacter = characterData[jsnum.value];
  if (currentCharacter) {
    homeOnRoleClickReporting(
      jstype.value == 1 ? currentCharacter.id : currentCharacter.id + 3
    );
  }
};

// 地图部分轮播
const mySwiper4 = ref(null); // 定义一个ref来保存Swiper实例
const mapNum = ref(1); // 定义一个ref来保存当前地图的索引
const onSwiper4 = (swiper4) => {
  mySwiper4.value = swiper4;
};
const mapSound = () => {
  if (bgmState.value) {
    mapSounds.value = true;
    // setTimeout(() => {
    //     document.querySelector('.bgm').pause();
    //     // bgmState.value = false;
    // }, 50);
  }
};
const onSlideChange4 = () => {
  if (mySwiper4.value) {
    mapNum.value = mySwiper4.value.realIndex + 1;
    document.getElementById("map_vid1").pause();
    document.getElementById("map_vid2").pause();
    document.getElementById("map_vid3").pause();
    // document.getElementById("map_vid4").pause();
    document.getElementById("map_vid4").pause();
    setTimeout(() => {
      document.getElementById("map_vid" + mapNum.value).play();
    }, 100);
    homeOnMapClickReporting(mapNum.value);
  }
};

// Swiper切屏
const showNews = ref(false); // 定义一个ref来保存是否显示新闻
SwiperCore.use([Mousewheel, Autoplay, Pagination]);
const navNum = ref(0); // 定义一个ref来保存当前导航的索引
const slgSrc = ref("img/pc/slogan.png");
const onSwiper = (swiper) => {
  mySwiper.value = swiper;
  slgSrc.value = "img/pc/slogan.png?d" + Date.now();
};
const onSlideChange = () => {
  //首页视频
  if (mySwiper.value.activeIndex == 0) {
    slgSrc.value = "img/pc/slogan.png?d" + Date.now();
    document.getElementById("index_video").play();
  } else {
    document.getElementById("index_video").pause();
  }
  // 角色页视频
  if (mySwiper.value.activeIndex == 1) {
    const currentCharacter = characterData[jsnum.value];
    if (currentCharacter) {
      homeOnRoleClickReporting(
        jstype.value == 1 ? currentCharacter.id : currentCharacter.id + 3
      );
    }
  }
  // 地图页视频
  // mapSounds.value = false;
  if (mySwiper.value.activeIndex == 2) {
    // document.querySelector('.map_video').pause();
    document.getElementById("map_vid" + mapNum.value).play();
    // console.log(pageClick.value)
    if (pageClick.value) {
      mapSound();
    }
  } else {
    document.getElementById("map_vid1").pause();
    document.getElementById("map_vid2").pause();
    document.getElementById("map_vid3").pause();
    // document.getElementById("map_vid4").pause();
    document.getElementById("map_vid4").pause();
    // if(bgmState.value){
    //     document.querySelector('.bgm').play();
    // }
  }

  if (mySwiper.value.activeIndex == 3) {
    showNews.value = true;
  } else {
    showNews.value = false;
  }

  navNum.value = mySwiper.value.activeIndex;
  document.documentElement.style.pointerEvents = "none";
  setTimeout(() => {
    document.documentElement.style.pointerEvents = "auto";
    document.getElementsByClassName("top_box")[0].style.display = "flex";
  }, 400);
};
// 提前加载
function onSwiperInit(swiper) {
  // 等待一帧再懒加载，避免第一次卡顿
  // console.log(swiper.activeIndex)
  setTimeout(() => {
    swiper.lazy.loadInSlide(swiper.activeIndex + 2);
    swiper.lazy.loadInSlide(swiper.activeIndex + 3);
  }, 30);
}
// 左2和右2的地图icon点击事件
const mapNext = () => {
  mySwiper4.value.update();
  mySwiper4.value.slideNext();
  document.getElementById("map_clickbgm").play();
};
const mapPrev = () => {
  mySwiper4.value.update();
  mySwiper4.value.slidePrev();
  document.getElementById("map_clickbgm").play();
};
// 给最左和最右的地图icon添加点击事件
onMounted(() => {
  document.querySelectorAll(".map_to").forEach((item) => {
    item.addEventListener("click", function () {
      const currentSlide = this.closest(".swiper-slide");
      const prevSlide = currentSlide?.previousElementSibling;

      if (prevSlide?.classList.contains("swiper-slide-next")) {
        // console.log('命中前一个是 swiper-slide-next');
        mySwiper4.value.slideNext(0);
        mySwiper4.value.slideNext();
      } else {
        // console.log('命中前一个不是 swiper-slide-next');
        mySwiper4.value.slidePrev(0);
        mySwiper4.value.slidePrev();
      }
      document.getElementById("map_clickbgm").play();
    });
  });
});

// 跳指定页
const goToSlide = (index) => {
  // console.log(index)
  // if (mySwiper.value) {
  mySwiper.value.slideTo(index);
  // }
};

// 点击弹窗视频并且播放
const popVideo = ref(false);
const showVideo = () => {
  homeOnPlayClickReporting();
  popVideo.value = true;
  document.querySelector(".bgm").pause();
};
const hideVideo = () => {
  popVideo.value = false;
  if (bgmState.value) {
    document.querySelector(".bgm").play();
  }
};

// 右下角icon收起显示
const showRbut = ref(true);

// 复制链接
const copyTips = ref(false);
const copyLink = () => {
  const link = window.location.href;
  const input = document.createElement("input");
  input.value = link;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
  copyTips.value = true;
  setTimeout(() => {
    copyTips.value = false;
  }, 1000);
};
</script>

<style lang="scss" scoped>
@use "./pc" as pc;
</style>
